const queryStringEncode = (obj: any, prefix?: string): string => {
  const str: string[] = [];
  Object.keys(obj).forEach((p) => {
    const k = prefix ? `${prefix}[${p}]` : p;
    const v = obj[p];
    str.push(v !== null && typeof v === 'object' ? queryStringEncode(v, k) : `${k}=${v}`);
  });
  return str.join('&');
};

export default queryStringEncode;
